import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import styles from './goals.css';
import classNames from 'classnames';

const { div, h2, p } = hh(h);

export default ({ image, title, text, className }) => (
  div({className: classNames(styles.goal, className)}, [
      div({ className: styles.goalImage }, h('img', {src: image, alt: ''})),
      div({ className: styles.goalBody }, [
          h2({ className: styles.goalTitle }, title),
          ...text.map( t => p(t) )
      ])
  ])
);


/** WEBPACK FOOTER **
 ** ./src/Universities/Goal.js
 **/